module.exports = __webpack_public_path__ + "static/media/Clear.6d6cae3a.svg";